/**
 * 시그니처 2: 커버리지 마이크로바 (DESIGN §8.6).
 *
 * **`meta.coverage` 를 받으면 자동으로 렌더된다** — 가동률 옆에 커버리지가
 * 붙지 않는 화면을 만들 수 없게 하는 것이 이 컴포넌트의 목적이다 (§7.1).
 * 실측에서 STALE 44% 였으므로 커버리지는 부가정보가 아니라 해석의 전제다.
 */

import type { Meta } from '@/lib/types'
import './CoverageBar.css'

interface Props {
  meta: Pick<Meta, 'coverage' | 'population_n' | 'n_excluded_low_coverage'>
  /** 컴팩트: 위젯 헤더용. 기본: 페이지 헤더용 */
  compact?: boolean
}

export function CoverageBar({ meta, compact = false }: Props) {
  const pct = Math.max(0, Math.min(1, meta.coverage))
  const label = `관측 커버리지 ${(pct * 100).toFixed(1)}%`

  return (
    <div className={`coverage${compact ? ' coverage--compact' : ''}`}>
      {/* 막대와 그 아래 이름 — 숫자만 있으면 무엇의 비율인지 알 수 없다.
          툴팁은 마우스를 올려야 보이므로 설명이 되지 못한다. */}
      <div className="coverage__col">
        <div
          className="coverage__track hatch-missing"
          role="meter"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={Number((pct * 100).toFixed(1))}
          aria-label={label}
          title={`${label} — 나머지는 관측되지 않은 시간입니다 (0 이 아니라 '모름')`}
        >
          <div className="coverage__fill" style={{ width: `${pct * 100}%` }} />
        </div>
        <span className="coverage__cap">관측 커버리지</span>
      </div>
      <span className="coverage__text num">{(pct * 100).toFixed(1)}%</span>
      {!compact && (
        <span className="coverage__meta">
          모집단 <span className="num">{meta.population_n.toLocaleString('ko-KR')}</span>기
          {meta.n_excluded_low_coverage > 0 && (
            <>
              {' · '}관측 부족 분리{' '}
              <span className="num">{meta.n_excluded_low_coverage.toLocaleString('ko-KR')}</span>건
            </>
          )}
        </span>
      )}
    </div>
  )
}
